/*
 * Fallback tenant / app identifiers used before the user logs in (needed by
 * the very first discover call, which must carry an X-App-ID header so the
 * BFF can inject it as `clientId` into the TenantHub discover request).
 *
 * `appId` prefers the build-time env var `VITE_APP_ID` so UAT / prod / dev
 * can use different Keycloak client registrations without a code change.
 * Falls back to the hardcoded GUID for local development if the env var is
 * missing. `tenantId` remains hardcoded because pre-login there is no
 * tenant context — the discover response tells us which tenants are
 * accessible, and `authService.login()` sets the resolved tenant via
 * `tokenStore.setTenantId(...)` after authenticate.
 */
export const DEV_DEFAULTS = {
  tenantId: 'adc75548-c9b7-4962-9978-05114a71e856',
  appId:
    (import.meta.env.VITE_APP_ID as string | undefined) ||
    '95cb8ffd-24ef-4839-8b62-8aca56c6dd5b',
} as const;
